/* eslint-disable react/jsx-props-no-spreading */
import { Collapse } from 'react-bootstrap';
import type { FunctionComponent } from 'react';
import type { AccordionBodyProps } from './useAccordion';

type Props = AccordionBodyProps & {
  isOpen: boolean;
};

/**
 * The body of the accordion component. Holds any arbitrary content.
 */
const Body: FunctionComponent<Props> = ({ children, isOpen, ...props }) => (
  <Collapse in={isOpen}>
    <div {...props}>
      {children}
    </div>
  </Collapse>
);

Body.displayName = 'AccordionBody';

export default Body;
